<mat-button-toggle-group>
	<mat-button-toggle (click)="downloadFile(id, fileType !== 'pdf' ? defaultFileType : fileType)"
					   matTooltip="Download" matTooltipPosition="left">
		{{defaultFileType === 'NO_CONVERSION' || fileType === 'pdf' ? (fileType | uppercase) : defaultFileType}}
	</mat-button-toggle>
	<mat-button-toggle>
		<mat-icon *ngIf="fileType !== 'pdf'" [matMenuTriggerFor]="menu">
			keyboard_arrow_down
		</mat-icon>
	</mat-button-toggle>
</mat-button-toggle-group>
<mat-menu #menu="matMenu">
	<button (click)="downloadFile(id, 'BMP')" mat-menu-item>BMP</button>
	<button (click)="downloadFile(id, 'JPG')" mat-menu-item>JPG</button>
	<button (click)="downloadFile(id, 'PDF')" mat-menu-item>PDF</button>
	<button (click)="downloadFile(id, 'PNG')" mat-menu-item>PNG</button>
	<button (click)="downloadFile(id, 'TIF')" mat-menu-item>TIF</button>
</mat-menu>
